import { CheckboxIcon } from '@snapi/icons';
import capitalize from 'lodash.capitalize';
import { Subtitle } from '../subtitle';

interface SelectorProps {
  title: string;
  selected: string[];
  options: string[];
  onChange(selected: string[]): void;
}

export const Selector: React.FC<SelectorProps> = ({
  title,
  options,
  selected,
  onChange,
}) => {
  const handleSelectAll = () => {
    if (options.length === selected.length) {
      onChange([]);
    } else {
      onChange(options);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-1">
        <h5 className="flex self-center">{title}</h5>
        <span
          className="cursor-pointer opacity-60 ml-3 flex self-center"
          onClick={handleSelectAll}
        >
          <Subtitle>Select all</Subtitle>
        </span>
      </div>
      <div className="grid sm:grid-cols-2 mt-3">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              className="flex flex-1 mb-2"
              onClick={() =>
                active
                  ? onChange(selected.filter((opt) => opt !== option))
                  : onChange(selected.concat(option))
              }
            >
              <div className="flex h-5 self-start items-center">
                <CheckboxIcon selected={active} />
              </div>
              <span className="flex ml-3 self-start text-sm text-left font-normal">
                {capitalize(option)}
              </span>
            </button>
          );
        })}
      </div>
      <div className="flex flex-1">
        <small
          className="cursor-pointer opacity-60"
          onClick={() => onChange([])}
        >
          Clear all
        </small>
      </div>
    </div>
  );
};
